import { render, staticRenderFns } from "./secondsOrder.vue?vue&type=template&id=a1099038&scoped=true&"
import script from "./secondsOrder.vue?vue&type=script&lang=js&"
export * from "./secondsOrder.vue?vue&type=script&lang=js&"
import style0 from "./secondsOrder.vue?vue&type=style&index=0&id=a1099038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1099038",
  null
  
)

export default component.exports